const DenmarkFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="20" fill="#C8102E"/>
    <rect x="4" width="6" height="20" fill="#FFFFFF"/>
    <rect y="8" width="30" height="4" fill="#FFFFFF"/>
  </svg>
);

export default DenmarkFlag;